import { getAuthTokenAsync } from "src/store/common";
import { LiveUser, Meta, User } from "src/store/types";
import * as api from "./api";

interface ApiResponse {
  data: LiveUser[];
  meta: Meta;
}

interface ViewersApiResponse {
  data: User[];
  meta: Meta;
}

// fetch all live users
export const fetchLiveUserList = async (data: {
  page: number;
  limit: number;
  search?: string;
}): Promise<ApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };

  if (data.search && data.search.trim()) {
    params.search = data.search.trim();
  }
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/live`,
    params,
  );
  return response;
};

// Generate agora token
export const generateAgoraToken = async (payload: {
  channelName?: string;
  role?: "publisher" | "audience";
}) => {
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.post(
    `${process.env.REACT_APP_API_URL}/agora/generate-agora-token`,
    payload,
  );
  return response;
};

export const fetchViewersList = async (data: {
  liveId: number;
  page: number;
  limit: number;
}): Promise<ViewersApiResponse> => {
  const params: any = {
    page: data.page,
    limit: data.limit,
  };
  const token = getAuthTokenAsync();
  api.setHeaderAuthorization(token);
  const response: any = await api.get(
    `${process.env.REACT_APP_ADMIN_API_URL}/live/viewers/${data.liveId}`,
    params,
  );
  return response;
};
